module.exports = __webpack_public_path__ + "static/media/calling-all-creators-hero.bb5535df.png";